import { useEffect, useState } from "react";
import { convertAssetIDToLocalTime } from "../../../utils/timeRelatedFunctions";
import { getGeeTileIds } from "../api/checkAssetId";


export function useFetchJsonFromS3() {
  const [calculatedTimeList, setCalculatedTimeList] = useState<string[]>([]);
  useEffect(() => {
    getGeeTileIds()
    .then(response => {
      if (!!response.data && !!response.data.file_path) {
        setCalculatedTimeList(response.data.file_path);
      } 
    })
    .catch(error => {
      throw error;
    });
  }, [])
  return {calculatedTimeList}
}

export const years:number[] =[2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
export const months:number[] =Array.from({ length: 12 }, (_, index) => index + 1);
export const dates:number[] =Array.from({ length: 31 }, (_, index) => index + 1);
export const hours:number[] =Array.from({ length: 8 }, (_, index) => index *3);

const createCalcTimeList = ():string[] => {
  const year = 2019
  const month = 10
  const dates:number[] =Array.from({ length: 8 }, (_, index) => index + 8);
  const hours:number[] =Array.from({ length: 8 }, (_, index) => index *3);

  const result: string[] = []
  for (const date of dates) {
    for (const hour of hours) {
      const dateString = `te_flddph_${year}${month.toString().padStart(2, '0')}${date.toString().padStart(2, '0')}${hour.toString().padStart(2, '0')}`;
      result.push(dateString);
    }
  }
    return result
}

export const calculatedTimeList = createCalcTimeList()

export const crtCalculatedTimeObj = (items:string[]) => {
  // returns [2019: []]
  let tree:DateTree = {}
  for (const time of items){
    const date = convertAssetIDToLocalTime(time)
    const dateLocal = new Date(date?.getTime() || 0)
    if (!date){continue}
    const year = dateLocal.getFullYear()
    const month = dateLocal.getMonth() + 1
    const day = dateLocal.getDate()
    const hour = dateLocal.getHours() 
    if (!tree[year]) {
      tree[year] = {};
  }

  if (!tree[year][month]) {
      tree[year][month] = {};
  }

  if (!tree[year][month][day]) {
    tree[year][month][day] = [];
}

tree[year][month][day].push(hour);
};

return tree;
}

type DateTree = {
  [year: number]: {
      [month: number]: {
          [day: number]: number[];
      };
  };
};